const IS_DEV = process.env.NODE_ENV !== 'production';

const DEV_ONLY_ROUTES = ['/quote'];

export function cleanRoutesOnProd(navList: Array<Record<string, any>>) {
  return IS_DEV ? navList : navList.filter((route) => !DEV_ONLY_ROUTES.includes(route?.path || route?.to));
}
